// Deployment-level constant, set at build time (see package.json's build:production
// script) -- NOT admin-editable, mirrors server/config/journalConfig.js's SITE_URL.
// Used to build canonical URLs, OG/Twitter meta tags, and JSON-LD across the site.
export const SITE_URL = (import.meta.env.VITE_SITE_URL || 'https://your-journal-domain.com').replace(/\/$/, '');
export const OG_IMAGE_URL = `${SITE_URL}/og-image.png`;
export const LOGO_URL = `${SITE_URL}/logo.png`;

// Fallback values shown while /api/journal/settings is loading, or if the request fails.
// Kept in sync with the schema defaults in server/models/JournalSettings.js -- for a
// different deployment, either update both, or (better) rely on the live settings
// response and only touch this file if the API is genuinely unreachable.
export interface JournalSettings {
  journalName: string;
  journalAbbreviation: string;
  issnOnline: string;
  issnPrint: string;
  contactEmail: string;
  contactPersonName: string;
  contactPersonRole: string;
  contactPersonEmail: string;
  contactPhonePrimary: string;
  contactPhoneSecondary: string;
  address: string;
  publisherName: string;
  publisherUrl: string;
  twitterHandle: string;
  stats?: {
    acceptanceRate: number;
    medianWeeksToFirstDecision: number;
    medianWeeksToFinalDecision: number;
    medianWeeksToPublication: number;
    avgReviewersPerArticle: number;
    countriesRepresented: number;
  };
}

export const DEFAULT_JOURNAL_SETTINGS: JournalSettings = {
  journalName: 'Your Journal Name',
  journalAbbreviation: '',
  issnOnline: '',
  issnPrint: '',
  contactEmail: '',
  contactPersonName: '',
  contactPersonRole: 'Editor-in-Chief',
  contactPersonEmail: '',
  contactPhonePrimary: '',
  contactPhoneSecondary: '',
  address: '',
  publisherName: '',
  publisherUrl: '',
  twitterHandle: ''
};
